// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamAccountProfile"]);
}

function unwrap_fragment_TeamAccountProfile_members_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DisplayOnlyMember",
    "UserBoundMember"
  ]);
}

let fragmentConverter = {"__root":{"TeamAccountProfile_members_edges_node_UserBoundMember":{"f":""},"TeamAccountProfile_members_edges_node_DisplayOnlyMember":{"f":""},"TeamAccountProfile_members_edges_node":{"u":"fragment_TeamAccountProfile_members_edges_node"},"":{"u":"fragment"}}};

let fragmentConverterMap = {
  fragment_TeamAccountProfile_members_edges_node: unwrap_fragment_TeamAccountProfile_members_edges_node,
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnifiedProfileSave_updatedMembers",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "TeamAccountProfileMemberConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamAccountProfileMemberEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UnifiedTeamAccountProfileMemberRow_userMember"
                        }
                      ],
                      "type": "UserBoundMember",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UnifiedTeamAccountProfileMemberRow_displayOnlyMember"
                        }
                      ],
                      "type": "DisplayOnlyMember",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "members(first:100)"
        }
      ],
      "type": "TeamAccountProfile",
      "abstractKey": null
    }
  ],
  "type": "AccountProfile",
  "abstractKey": "__isAccountProfile"
};
})());

let wrap_fragment = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_TeamAccountProfile_members_edges_node = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.unwrap_fragment_TeamAccountProfile_members_edges_node = unwrap_fragment_TeamAccountProfile_members_edges_node;
exports.wrap_fragment_TeamAccountProfile_members_edges_node = wrap_fragment_TeamAccountProfile_members_edges_node;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
